import type { Theme } from '@mui/material'

const GROUP = '[data-hover-reveal-group]'
const TARGET = '[data-hover-reveal]'

// Opacity rather than visibility, so a hidden target stays focusable and tabbing to it reveals it. Only keyboard
// focus reveals, so a mouse click doesn't leave the target showing once the pointer has gone. The open-menu
// rule keys on aria-expanded because a portalled menu leaves the group, and with it :hover. A group must not
// contain another group's targets: every target inside it would follow the outer group too.
export const hoverRevealStyles = (theme: Theme) => ({
  '@media (hover: hover)': {
    [`${GROUP} ${TARGET}:not([data-hover-reveal-shown])`]: {
      opacity: 0,
      transition: theme.transitions.create('opacity'),
      '@media (prefers-reduced-motion: reduce)': { transition: 'none' },
    },
    // Same specificity as the rule above, so these win by coming after it.
    [`${GROUP}:hover ${TARGET}`]: { opacity: 1 },
    [`${GROUP}:focus-visible ${TARGET}`]: { opacity: 1 },
    [`${GROUP}:has(:focus-visible) ${TARGET}`]: { opacity: 1 },
    [`${GROUP}:has([aria-expanded='true']) ${TARGET}`]: { opacity: 1 },
  },
})
